import {
  Add_New_Commission,
  Delete_Selected_Commission_Type,
  Get_All_Leads_Commissions_For_Selected_Lead,
  Get_Error,
  Get_One_Commission_Type,
  Update_Selected_Commisssion_Type,
} from '../Types';

const intial = {
  Add_Commission: [],
  Update_Selected_Lead_Commission: [],
  loading: true,
};

const Commission_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_New_Commission:
      return {
        ...state,
        Add_Commission: action.payload,
        loading: false,
      };
    case Get_All_Leads_Commissions_For_Selected_Lead:
      return {
        ...state,
        Add_Commission: action.payload,
        loading: false,
      };
    case Get_One_Commission_Type:
      return {
        ...state,
        Add_Commission: action.payload,
        loading: false,
      };
    case Update_Selected_Commisssion_Type:
      return {
        ...state,
        Update_Selected_Lead_Commission: action.payload,
        loading: false,
      };
    case Delete_Selected_Commission_Type:
      return {
        ...state,
        Add_Commission: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Add_Commission: action.payload,
      };
    default:
      return state;
  }
};

export default Commission_Reducer;
